/**
 * ATELIER LUXURY SHOPIFY THEME - VARIANT SELECTS & PRODUCT FORM
 */

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('section');
    this.variantsJson = JSON.parse(this.querySelector('.product-variants-json')?.textContent || '[]');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedLabels();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updatePrice();
      this.updateSKU();
      this.updateAvailability();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  updateSelectedLabels() {
    this.querySelectorAll('fieldset').forEach((fieldset, idx) => {
      const label = fieldset.querySelector('[data-header-option-current]');
      if (label && this.options[idx]) {
        label.textContent = this.options[idx];
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.variantsJson.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    this.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant: this.currentVariant }
    }));
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    const priceContainer = this.section?.querySelector('.price-container');
    if (!priceContainer || !this.currentVariant) return;

    const regularPriceEl = priceContainer.querySelector('.price-item--regular');
    const comparePriceEl = priceContainer.querySelector('.price-item--compare');
    const saleBadge = priceContainer.querySelector('.price-badge--sale');

    if (regularPriceEl) {
      regularPriceEl.textContent = window.formatMoney(this.currentVariant.price);
    }

    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      priceContainer.classList.add('price--on-sale');
      if (comparePriceEl) {
        comparePriceEl.textContent = window.formatMoney(this.currentVariant.compare_at_price);
        comparePriceEl.parentElement.hidden = false;
      }
      if (saleBadge) {
        const pct = Math.round(((this.currentVariant.compare_at_price - this.currentVariant.price) * 100) / this.currentVariant.compare_at_price);
        saleBadge.textContent = `-${pct}%`;
        saleBadge.hidden = false;
      }
    } else {
      priceContainer.classList.remove('price--on-sale');
      if (comparePriceEl?.parentElement) {
        comparePriceEl.parentElement.hidden = true;
      }
      if (saleBadge) {
        saleBadge.hidden = true;
      }
    }

    // Sync mobile sticky bar price
    const stickyPrice = this.section?.querySelector('[data-sticky-price]');
    if (stickyPrice) {
      stickyPrice.textContent = window.formatMoney(this.currentVariant.price);
    }
  }

  updateSKU() {
    const skuEl = this.section?.querySelector('[data-product-sku]');
    if (skuEl) {
      skuEl.textContent = this.currentVariant?.sku || '';
    }
  }

  updateAvailability() {
    const addButton = this.section?.querySelector('[name="add"]');
    const addButtonText = addButton?.querySelector('.button-text');
    const idInput = this.section?.querySelector('input[name="id"]');
    const stickyBtn = this.section?.querySelector('[data-sticky-trigger]');

    if (idInput && this.currentVariant) {
      idInput.value = this.currentVariant.id;
    }

    if (!this.currentVariant.available) {
      if (addButton) {
        addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'Sold Out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Sold Out';
      }
    } else {
      if (addButton) {
        addButton.disabled = false;
        if (addButtonText) addButtonText.textContent = 'Add to Cart';
      }
      if (stickyBtn) {
        stickyBtn.disabled = false;
        stickyBtn.textContent = 'Add to Cart';
      }
    }
  }

  setUnavailable() {
    const addButton = this.section?.querySelector('[name="add"]');
    const addButtonText = addButton?.querySelector('.button-text');
    if (addButton) {
      addButton.disabled = true;
      if (addButtonText) addButtonText.textContent = 'Unavailable';
    }
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

// Mobile Sticky Bar Intersection Observer
document.addEventListener('DOMContentLoaded', () => {
  const mainBtn = document.querySelector('.product-form__submit');
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const stickyTrigger = document.querySelector('[data-sticky-trigger]');

  if (mainBtn && stickyBar) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBtn);

    stickyTrigger?.addEventListener('click', () => {
      mainBtn.click();
    });
  }
});
